import styled from '@emotion/styled';
import React from 'react';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { __permissionsObj, __snackBarSeverity, __snackBarText } from '../../constants';
import mainContext from '../../contexts/mainContext';
import { addAreaController, getAreasListing, getCitiesListing, removeAreaController } from '../../Controllers/ScopeManagement';
import { FormControl, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material';
import { Delete, Label } from '@mui/icons-material';
import Sorting from '../../common_components/Sorting';

function FormDialog({ open, handleClose, handleAdd }) {
    const [cities, setCities] = React.useState([]);
    const [selectedCity, setSelectedCity] = React.useState("");

    const getCityList = async () => {
        const res = await getCitiesListing();
        setCities(res.data.data)
    }
    const handleSelect = (e) => {
        setSelectedCity(e.target.value)
    }
    React.useEffect(() => {
        getCityList();
    }, [])
    return (
        <>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add new area</DialogTitle>
                <DialogContent>
                    <div>
                        <InputLabel id="city" sx={{ margin: '0', padding: "0" }}>City</InputLabel>
                        <Select
                            autoFocus
                            variant="standard"
                            sx={{ width: "300px" }}
                            labelId="city"
                            label="city"
                            multiple={false}
                            onChange={handleSelect}>
                            {cities.map((e) => (
                                <MenuItem value={e._id}>{e.city}</MenuItem>
                            ))}
                        </Select>
                        {/* </FormControl> */}
                    </div>
                    <TextField
                        margin="dense"
                        id="area"
                        // multiline={true}
                        label="Area name"
                        type="text"
                        fullWidth
                        variant="standard"
                        placeholder='Area 1, Area 2'
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} size="small" >Cancel</Button>
                    <Button onClick={() => { handleAdd(selectedCity, document.getElementById("area").value) }} variant="contained" size="small" >Add</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
const Areas = () => {
    const { setSnackBar, setProfileNavTitle, setPageload, pageload } = React.useContext(mainContext);
    const [open, setOpen] = React.useState(false);
    const [areas, setAreas] = React.useState([]);
    
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = async (id) => {
        setPageload(true)
        const res = await removeAreaController(id);
        setPageload(false)
        if (res && res.status === 500) {
            return setSnackBar({
                status: true,
                text: __snackBarText.internalServerError,
                severity: __snackBarSeverity.error
            });;
        }
        if (res.data.status !== 200) {
            return setSnackBar({
                status: true,
                text: res.data.errors[0].message,
                severity: __snackBarSeverity.error
            });
        }
        setAreas(areas.filter(item => item._id !== id));
        setSnackBar({
            status: true,
            text: "Area deleted successfully",
            severity: __snackBarSeverity.success
        });
    }

    const handleAdd = async (cityId, area) => {
        if (!cityId) {
            return setSnackBar({
                status: true,
                text: "Please select city",
                severity: __snackBarSeverity.error
            })
        }
        else if (!area) {
            return setSnackBar({
                status: true,
                text: "Please enter area name",
                severity: __snackBarSeverity.error
            })
        }
        else {
            // const reg = new RegExp(/^[a-zA-Z 0-9, '.-]*$/gi)
            // const res = reg.test(area.replace(/\n/g, " "));
            // if (!res) {
            //     return setSnackBar({
            //         status: true,
            //         text: "Please enter valid area name.",
            //         severity: __snackBarSeverity.error
            //     })
            // }
        }
       
        setPageload(true)
        const res = await addAreaController(cityId, area);
        setPageload(false)
        if (res && res.data.status === 200) {
            let updatedList = [...res.data.data.area]
            updatedList.forEach((obj)=>{
                obj.cityId={
                    _id: obj.cityId,
                    city: res.data.data.city
                } 
            })
            setAreas([...areas, ...updatedList]);
            setSnackBar({
                status: true,
                text: "Area added successfully",
                severity: __snackBarSeverity.success
            });
            setOpen(false);
        }
        if (res.data.status !== 200) {
            return setSnackBar({
                status: true,
                text: res.data.message,
                severity: __snackBarSeverity.error
            });
        }

    }

    const getAreas = async () => {
        setPageload(true)
        const res = await getAreasListing();
        setPageload(false)
        if (res && res.status === 500) {
            return setSnackBar({
                status: true,
                text: __snackBarText.internalServerError,
                severity: __snackBarSeverity.error
            })
        }
        if (res.data.status !== 200) {
            return setSnackBar({
                status: true,
                text: res.data.message,
                severity: __snackBarSeverity.error
            });
        }
        setAreas(res.data.data);
    }

    React.useEffect(() => {
        getAreas();
        setProfileNavTitle("Available Areas");
        // eslint-disable-next-line
    }, [])

    return (
        <>
            {<FormDialog open={open} handleClose={handleClose} handleAdd={handleAdd} />}
            <Conatiner>
                <Header>
                    <Button variant="contained" size='small' onClick={handleClickOpen}>Add new</Button>
                </Header>
                <Body>
                    <List>
                        <div className="header">City</div>
                        <div className="header">Areas</div>
                        <div style={{ textAlign: "right" }}>Actions</div>
                    </List>
                    <Divider className='divider-gap' />
                    {
                        areas.map((item) => {
                            return (
                                <List key={item._id}>
                                    <div>
                                        {item.cityId.city}
                                    </div>
                                    <div>
                                        {item.area}
                                    </div>
                                    <div style={{ textAlign: "right" }}>
                                        <Delete className='pointer' sx={{ marginRight: 2 }} onClick={() => handleDelete(item._id)} />
                                    </div>
                                </List>
                            )
                        })
                    }
                    {areas.length === 0 && !pageload && <div className='no-record'><span>No Record Found</span></div>}

                </Body>
            </Conatiner>
        </>
    )
}

const Conatiner = styled("div")`
  .divider-gap{
        margin: 0.5rem 0;
  }
  button{
    text-transform: none;
  }
`;

const Header = styled("div")`
  button{
    border-radius: 5px;
  }
`;
const Body = styled("div")`
  height: 80vh;
`;

const List = styled("div")`
.header{
    font-family: "semi-bold";
}
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 2fr 8fr 2fr;
`;

export default Areas